import { useContext } from 'react';

import { ToastContext, AlertProps } from '../context/toast';

export const useToast = () => useContext<{ addAlert: (toast: AlertProps) => void }>(ToastContext);
